export enum Region {
  APAC = 'APAC',
  EMERGING = 'Emerging',
  EUROPE = 'Europe',
  GLOBAL = 'Global',
  JAPAN = 'Japan',
  UK = 'UK',
  US = 'US',
}
